module.exports = __webpack_public_path__ + "static/media/Nia_Terms_of_Use.a07e019a.pdf";